import { render, staticRenderFns } from "./BookingSummaryData.vue?vue&type=template&id=082f36f4"
import script from "./BookingSummaryData.vue?vue&type=script&lang=js"
export * from "./BookingSummaryData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports